const ITEMS = [
  "Results That Move You",
  "Luxury",
  "Commercial",
  "Rural",
  "Mississauga",
  "Etobicoke",
  "Oakville",
  "Toronto",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-7 text-[12px] font-medium uppercase tracking-[0.34em] text-ink/80 sm:px-10">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-hairline bg-white py-6" data-testid="brand-marquee">
      <div className="marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}